import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { orpc } from "@/orpc/client";
import { Dashboard } from "@/pages/dashboard/Dashboard";
import { DashboardPageSkeleton } from "@/pages/dashboard/DashboardPageSkeleton";

const SearchParamsSchema = z.object({
	success: z.enum(["verify-email"]).optional(),
});

export const Route = createFileRoute("/_app/dashboard/")({
	validateSearch: SearchParamsSchema,
	loader: async ({ context: { queryClient } }) =>
		queryClient.ensureQueryData(
			orpc.dashboard.stats.queryOptions({
				input: { days: 30 },
			}),
		),
	head: () => ({
		meta: [{ title: "Dashboard - Biteasy" }],
	}),

	pendingComponent: DashboardPageSkeleton,
	component: Dashboard,
});
